import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axiosInstance from '../../helpers/axios';
import { Autocomplete, TextField, InputAdornment,Grid } from "@mui/material";
import search from "../../assets/images/search.png";
import DatePicker from "react-multi-date-picker";
import calender from "../../assets/images/calender.png";
import moment from 'moment';
import download from "../../assets/images/download.png";
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';



export default function DiscountReport() {
    const [instituteList,setInstituteList]=useState([])
    const [startingPhrase,setStarterPhrase]=useState("Type Institute Name")
    const user = null;
    const [internalValue, setInternalValue] = useState(""); 
    const [instituteId,setInstituteId] =useState('');
    const startDateFrom = moment().startOf('month');
    const endDateTo = moment()
    const formattedStartDate = startDateFrom.format('YYYY-MM-DD');
    const formattedEndDate = endDateTo.format('YYYY-MM-DD');
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [searchQuery, setsearchQuery] = useState('')
    const [tableData, setTableData] = useState([])
    const [isLoading, setIsLoading] = useState(false);
  const productTypeSelected = useSelector((state) => state.ProductTypeFilter.selectedProductType);
   


   const clearFilter = () => {
     window.location.reload();
    };

    useEffect(() => {
      setIsLoading(true)
      let queryParams = {};

    
      if (dateFrom && dateTo) {
        queryParams.startDate = dateFrom;
        queryParams.endDate = dateTo;
      }else if (formattedStartDate && formattedEndDate){
      queryParams.startDate = formattedStartDate;
      queryParams.endDate = formattedEndDate;
      }
      
      if(instituteId){
        queryParams.instituteId = instituteId
      }
      if(searchQuery.startsWith("MCL")){
      queryParams.loanId =searchQuery
      }else if( searchQuery.startsWith("GBP")){
      queryParams.legacyLoanId =searchQuery
      }
      if (productTypeSelected && productTypeSelected !== "all") {
        queryParams.loanType = Number(productTypeSelected);
      }
      axiosInstance.get('/analytics/get-discount-data', {
        headers: {
        },
        params: queryParams // Pass the query params here
      })
      .then((res) => {
        setTableData(res?.data?.data);
          setIsLoading(false);
      })
      .catch((error) => {
      });
    }, [productTypeSelected]);
   
    const getInstituteInfo = async (text) => {
      const trimmedText = text.trim();
    
    
      if (!trimmedText || trimmedText.length < 4) {
        setInstituteList([]);
        setStarterPhrase("Type Institute Name");
        return;
      }
  
      const instituteInfoUrl = `/institute/info/name?name=${trimmedText}`;
      try {
        const response = await axiosInstance.get(instituteInfoUrl, {
          headers: {
          },
        });
    
        const institutes = response?.data?.data || [];
        if (institutes.length === 0) {
          setInstituteList([]);
          setStarterPhrase("No institute found");
        } else {
          const formattedData = institutes.map((item) => ({
            label: item.brandName,
            id: item.id,
            ...item,
          }));
          setInstituteList(formattedData);
          setStarterPhrase(""); // Clear starter phrase on successful fetch
        }
      } catch (error) {
        console.error("Error fetching institute info:", error);
      }}

    const handleDownloadList=()=>{
        const currentDate = new Date();
        const day = String(currentDate.getDate()).padStart(2, '0');
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const year = String(currentDate.getFullYear());
        const formattedDate = `${day}-${month}-${year}`;
        document.getElementById("downloadButton").disabled=true;
        document.getElementById("downloadButton").innerText="Wait....";
        document.getElementById("downloadButton").style.backgroundColor="#D22129";
        document.getElementById("downloadButton").style.color= "white";
        document.getElementById("downloadButton").style.fontFamily= "Inter-Medium";
        document.getElementById("downloadButton").style.fontSize= "15px";
        document.getElementById("downloadButton").style.width= "130px";
        document.getElementById("downloadButton").style.cursor= "pointer";
        document.getElementById("downloadButton").style.height= "34px";
        document.getElementById("downloadButton").style.borderRadius= "5px";
        document.getElementById("downloadButton").style.textAlign= "center";
        // document.getElementById("downloadButton").style.marginLeft="150px";
        document.getElementById("downloadButton").style.backgroundImage = "none"
    
        let queryParams = {}
      if (productTypeSelected && productTypeSelected !== "all") {
        queryParams.loanType = Number(productTypeSelected);
      }
        axiosInstance.get("/excel/getDiscoutReportData", {
          params: queryParams,
          responseType: 'arraybuffer',
          headers: {
          }
      }).then((res)=>{
        setTimeout(() => {
          document.getElementById("downloadButton").disabled=false
          document.getElementById("downloadButton").innerText="Export";
          document.getElementById("downloadButton").style.paddingLeft = "30px";
          document.getElementById("downloadButton").style.backgroundColor="#D22129";
          document.getElementById("downloadButton").style.color= "white";
          document.getElementById("downloadButton").style.fontFamily= "Inter-Medium";
          document.getElementById("downloadButton").style.fontSize= "15px";
          document.getElementById("downloadButton").style.width= "130px";
          document.getElementById("downloadButton").style.cursor= "pointer";
          document.getElementById("downloadButton").style.height= "34px";
          document.getElementById("downloadButton").style.borderRadius= "5px";
          document.getElementById("downloadButton").style.textAlign= "center";
          // document.getElementById("downloadButton").style.marginLeft= "30px";
          document.getElementById("downloadButton").style.backgroundImage = `url(${download})`
          document.getElementById("downloadButton").style.backgroundRepeat  ='no-repeat' 
          // document.getElementById("downloadButton").style.backgroundPositionY  ='20px' 
          document.getElementById("downloadButton").style.backgroundSize  ='15px' 
          document.getElementById("downloadButton").style.backgroundPosition  ='10px 10px'
    
        }, 2000);
        const blob = new Blob([res.data], { type: "application/xlsx", });
        const url= window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href =url
        link.download = `${formattedDate}.xlsx`;
    
        document.body.appendChild(link);
    
        link.click();
    
        document.body.removeChild(link);
      }
        
      ).catch((error)=>{
        alert("Error Downloading")
        document.getElementById("downloadButton").innerText="Error..";
        document.getElementById("downloadButton").style.backgroundColor="#D22129";
        document.getElementById("downloadButton").disabled=false
          document.getElementById("downloadButton").style.paddingLeft = "30px";
          document.getElementById("downloadButton").style.backgroundColor="#D22129";
          document.getElementById("downloadButton").style.color= "white";
          document.getElementById("downloadButton").style.fontFamily= "Inter-Medium";
          document.getElementById("downloadButton").style.fontSize= "15px";
          document.getElementById("downloadButton").style.width= "130px";
          document.getElementById("downloadButton").style.cursor= "pointer";
          document.getElementById("downloadButton").style.height= "34px";
          document.getElementById("downloadButton").style.borderRadius= "5px";
          document.getElementById("downloadButton").style.textAlign= "center";
          // document.getElementById("downloadButton").style.marginLeft= "30px";
          document.getElementById("downloadButton").style.backgroundImage = `url(${download})`
          document.getElementById("downloadButton").style.backgroundRepeat  ='no-repeat' 
          // document.getElementById("downloadButton").style.backgroundPositionY  ='20px' 
          document.getElementById("downloadButton").style.backgroundSize  ='15px' 
          document.getElementById("downloadButton").style.backgroundPosition  ='10px 10px'
        setTimeout(() => {
          document.getElementById("downloadButton").disabled=false
          document.getElementById("downloadButton").innerText="Export";
          // document.getElementById("downloadButton").style.paddingLeft = "30px";
          document.getElementById("downloadButton").style.backgroundColor="#D22129";
          document.getElementById("downloadButton").style.color= "white";
          document.getElementById("downloadButton").style.fontFamily= "Inter-Medium";
          document.getElementById("downloadButton").style.fontSize= "15px";
          document.getElementById("downloadButton").style.width= "130px";
          document.getElementById("downloadButton").style.cursor= "pointer";
          document.getElementById("downloadButton").style.height= "34px";
          document.getElementById("downloadButton").style.borderRadius= "5px";
          document.getElementById("downloadButton").style.textAlign= "center";
          // document.getElementById("downloadButton").style.marginLeft= "30px";
          document.getElementById("downloadButton").style.backgroundImage = `url(${download})`
          document.getElementById("downloadButton").style.backgroundRepeat  ='no-repeat' 
          // document.getElementById("downloadButton").style.backgroundPositionY  ='20px' 
          document.getElementById("downloadButton").style.backgroundSize  ='20px' 
          document.getElementById("downloadButton").style.backgroundPosition  ='15px 10px'
        }, 1000);
      })
      }
        
    function formatNumberWithCommas(number) {
        return number.toLocaleString('en-IN'); 
    }

     const fetchingData = ()=>{
        setIsLoading(true)
        let queryParams = {} 
       
       if (dateFrom && dateTo) {
          queryParams.startDate = dateFrom;
          queryParams.endDate = dateTo;
        }else if (formattedStartDate && formattedEndDate){
        queryParams.startDate = formattedStartDate;
        queryParams.endDate = formattedEndDate;
        }

        if(instituteId){
          queryParams.instituteId = instituteId
        }
       if(searchQuery.startsWith("MCL")){
        queryParams.loanId =searchQuery
        }else if( searchQuery.startsWith("GBP")){
        queryParams.legacyLoanId =searchQuery
        }
       if (productTypeSelected && productTypeSelected !== "all") {
         queryParams.loanType = Number(productTypeSelected);
       }
        axiosInstance.get('/analytics/get-discount-data', {
          params: queryParams,
          headers: {
          },
        })
        .then((res) => {
    
          setTableData(res?.data?.data);
          setIsLoading(false);
         
        })
        .catch((error) => {
          alert(error?.response?.data?.message)
          console.error("Error fetching filtered data:", error);
        })}

  return (
     <div style={{width:"100%",backgroundColor:'white',height:'130%'}}>

      <Grid container spacing={2} sx={{  marginTop: '20px' }}>
                <Grid item xs={12} sm={6} md={2.4} sx={{marginTop:'-2px'}}>
                    <DatePicker
                        value={dateFrom && dateTo ? [dateFrom, dateTo] : null}
                        style={{ height:'36px', BorderRadius: '5px',padding: '2px', backgroundRepeat: 'no-repeat', width: '100%',
                        backgroundPosition: '5px center',
                        backgroundSize: '15px 15px', backgroundImage: `url(${calender})`, paddingLeft: '30px',fontSize:"14px",fontWeight:"normal", border:'1px solid #ccc'}}
                        placeholder="Select date range"
                        allowClear={true}
                        format="YYYY-MM-DD"
                        onChange={(dates, dateStrings) => {
                            setDateFrom(dateStrings?.validatedValue[0])
                            setDateTo(dateStrings?.validatedValue[1])
                        }}
                        range
                        />
                </Grid>

                <Grid item xs={12} sm={6} md={2.4}>
                    <Autocomplete
                    freeSolo={false}
                    disablePortal
                    value={internalValue}
                    options={instituteList.map((item) => item.brandName)}
                    noOptionsText={startingPhrase}
                    onInputChange={(event, newInputValue, reason) => {
                        if (reason === 'clear' || newInputValue === '') {
                        setInstituteId('');
                        setInternalValue('');
                        setInstituteList([]);
                        return;
                        }
                        if (reason === 'input') {
                        setInternalValue(newInputValue);
                        getInstituteInfo(newInputValue);
                        }
                    }}
                    onChange={(event, selectedValue) => {
                        const selectedItem = instituteList.find(item => item.brandName === selectedValue);
                        if (selectedItem) {
                        setInstituteId(selectedItem.id);
                        setInternalValue(selectedItem.brandName);
                        }
                    }}
                    renderInput={(params) => (
                        <TextField
                        {...params}
                        placeholder="Inst.Name"
                        sx={{
                            width: '100%',
                            "& .MuiOutlinedInput-root": {
                            height: 36,
                            borderRadius: '7px',
                            "& fieldset": {
                                borderColor: "#e4e6e7",
                            },
                            "&:hover fieldset": {
                                borderColor: "#e4e6e7",
                            },
                            "&.Mui-focused fieldset": {
                                borderWidth: "4px",
                                borderColor: "#C2E0FF",
                            },
                            "& input": {
                                fontFamily: 'Outfit',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            },
                            },
                        }}
                        InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                            <InputAdornment position="start">
                                <img src={search} alt="Search" style={{ width: "20px", height: "20px" }} />
                            </InputAdornment>
                            ),
                            onKeyDown: (e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                            },
                        }}
                        />
                    )}
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={2.4}>
                    <TextField
                    variant="outlined"
                    placeholder="Loan Id"
                    onChange={(e) => setsearchQuery(e.target.value)}
                    size="small"
                    sx={{
                        width: '100%',
                        "& .MuiOutlinedInput-root": {
                        height: 36,
                        borderRadius: '5px',
                        "& fieldset": {
                            borderColor: "#e4e6e7",
                        },
                        "&:hover fieldset": {
                            borderColor: "#e4e6e7",
                        },
                        "&.Mui-focused fieldset": {
                            borderWidth: "4px",
                            borderColor: "#C2E0FF",
                        },
                        "& input": {
                            fontFamily: 'Outfit',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        },
                        },
                    }}
                    InputProps={{
                        startAdornment: (
                        <InputAdornment position="start">
                            <img src={search} alt="Search" />
                        </InputAdornment>
                        ),
                        onKeyDown: (e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        },
                    }}
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                 <div style={{ display: 'flex', gap: '20px' }}>
                    <button
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '340px',
                        backgroundColor: '#D22129',
                        height: '36px',
                        borderStyle: 'none',
                        borderRadius: "5px",
                        color: 'white',
                        fontFamily: "Inter-Medium",
                        justifyContent: 'center',
                        whiteSpace: 'nowrap'

                    }}
                    onClick={() => fetchingData()}
                    >
                    Search Results
                    </button>

                     <button
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '340px',
                        backgroundColor: '#D22129',
                        height: '36px',
                        border: 'none',
                        borderRadius: "5px",
                        color: 'white',
                        fontFamily: "Inter-Medium",
                        justifyContent: 'center',
                        whiteSpace: 'nowrap'
                      }}
                      onClick={() => clearFilter()}
                    >
                      Clear Filter
                    </button>
                    </div>    
                </Grid>


              <Grid item xs={12} sm={6} md={1}>
                        <div
                        style={{
                        backgroundColor: '#D22129',
                        display: 'flex',
                        alignItems: 'center',
                        width: '120px',
                        height: '36px',
                        borderRadius: '5px',
                        fontFamily: 'Inter-Medium',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        }}
                        id="downloadButton"
                        onClick={() => handleDownloadList()}
                        >
                        <img src={download} style={{ height: '20px', marginRight: '8px' }} alt="" />
                        <span style={{ color: 'white' }}>Export</span>
                        </div>

              </Grid>

      </Grid>

   
       {isLoading ? (
            <Box style={{ display: 'flex',alignItems:'center',justifyContent:'center',padding:'15%'}}>
            <CircularProgress />
        </Box>):(<>
          <div className='tables' style={{ marginTop: '20px' }}>
            
                  <table >
                      <thead className='table-heading'>
                            <tr>
                                <th style={{  fontSize: '14px',width:'8%',fontFamily:"Inter",paddingLeft:'10px'}}>Loan Id</th>
                                <th style={{  fontSize: '14px',width:'10%',fontFamily:"Inter"}}>EmiNo.</th>
                                <th style={{  fontSize: '14px',width:'10%',fontFamily:"Inter"}}>LoanAmt</th>
                                <th style={{  fontSize: '14px',width:'10%',fontFamily:"Inter"}}>Emi count</th>
                                <th style={{  fontSize: '14px',width:'10%',fontFamily:"Inter"}}>PaidAmt</th>
                                <th style={{  fontSize: '14px',width:'11%',fontFamily:"Inter"}}>DiscountAmt</th>
                                <th style={{  fontSize: '14px',width:'10%',fontFamily:"Inter"}}>Paid Date</th>
                                <th style={{  fontSize: '14px',width:'10%',fontFamily:"Inter"}}>Inst Name</th>
                            
                            </tr>
                        </thead>
                        <tbody className='table-body'>
                         {
                      Array.isArray(tableData) && tableData.length > 0 ? (
                        tableData.map((item, index) => (
                          <tr key={index} className="table-row" style={{ lineHeight: '1.3rem' }}>
                            <td style={{fontSize: '14px',  width: '10em',fontFamily: 'Inter',  color: '#667085'}}>{item.legacy_loan_id || ''}</td>
                            <td style={{fontSize: '14px',  width: '10em',fontFamily: 'Inter',  color: '#667085'}}>{item.emi_no || '-'}</td>
                            <td style={{fontSize: '14px',  width: '10em',fontFamily: 'Inter',  color: '#667085'}}>{item.loan_amount ? <>₹{formatNumberWithCommas(item.loan_amount)}</> : '-'}</td>
                            <td style={{fontSize: '14px',  width: '10em',fontFamily: 'Inter',  color: '#667085'}}>{item.emiCount || '-'}</td>
                            <td style={{fontSize: '14px',  width: '10em',fontFamily: 'Inter',  color: '#667085'}}>{item.Paid_amount ? <>₹{formatNumberWithCommas(item.Paid_amount)}</> : '-'}</td>
                            <td style={{fontSize: '14px',  width: '10em',fontFamily: 'Inter',  color: '#667085'}}>{item.DiscountAmount ? <>₹{formatNumberWithCommas(item.DiscountAmount)}</> : '-'}</td>
                            <td style={{fontSize: '14px',  width: '10em',fontFamily: 'Inter',  color: '#667085'}}>{item.emi_repaid_date || '-'}</td>
                             <td style={{fontSize: '14px',width: '10em', fontFamily: 'Inter',color: '#667085'}} title={item?.name? item.name.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '): '-' }>
                             <span title={item.name} style={{maxWidth: '10em',fontFamily: "Inter",lineHeight: '1.5em',display:"inline-block",whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}} >{item?.name?.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</span>{' '}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8" style={{ textAlign: 'center', padding: '10px', color: '#999' }}>
                            This Month Discount Data Not Available
                          </td>
                        </tr>
                      )
                    }
                   </tbody>
                </table>
    
              </div>
                </>)
          }

        </div>

  )
}
